import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import App from './App'; // Import App.jsx

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

reportWebVitals();